import { useEffect } from 'react';

import { initCSM } from '../../utils/initCSM';

type AiCornerAgentProps = {
	locale?: string;
	site?: string;
	siteId?: string;
	widgetId: string;
};

/**
 * Initialises the CSM widget when mounted
 */
export const AiCornerAgent = ({ locale, site, siteId, widgetId }: AiCornerAgentProps) => {
	useEffect(() => {
		initCSM({ locale, site, siteId, widgetId });
	}, [locale, site, siteId, widgetId]);

	return null;
};
